import { ManagementPageLayout } from '@/layouts/ManagementPageLayout'
import { Platform } from '@/ux'
import { DocsNavMenu } from './DocsNavMenu'
import { DocsSlugRouter } from './DocsSlugRouter'
import { useParams } from 'react-router'

const RESERVED_APP_KEYS = new Set([
  'docs',
  'projects',
  'workspaces',
  'applications',
  'subscriptions',
  'platform',
  'apps',
  'embedded',
  'chat-test',
  'oauth',
  'featured-apps',
])

export function UnityAppCatchAll() {
  const { appKey } = useParams()

  if (appKey === 'docs') {
    return <ManagementPageLayout menu={<DocsNavMenu />} content={<DocsSlugRouter />} />
  }

  if (appKey && RESERVED_APP_KEYS.has(appKey)) {
    return null
  }

  return <Platform />
}
